import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

class HeaderStageVC extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      trigger: false,
    }
    this.firstFunction = this.firstFunction.bind(this)
  }

  firstFunction() {}

  render() {
    const {
      bgimage,
      bgimagefront,
      logo,
      headline,
      buttonlabel,
      current_url_with_anchor,
    } = this.props

    return (
      <div
        className="dhsv_vc_header_stage"
        style={{ backgroundImage: `url(${bgimage})` }}
      >
        <div
          className="dhsv_vc_header_stage_bg"
          style={{ backgroundImage: `url(${bgimagefront})` }}
        ></div>
        <div
          className="dhsv_vc_header_stage_logo"
          dangerouslySetInnerHTML={{ __html: logo }}
        />
        <h1 className="dhsv_vc_header_stage_headline">{headline}</h1>
        <a className="dhsv_vc_header_stage_btn" href={current_url_with_anchor}>
          {buttonlabel}
        </a>
        <a
          className="dhsv_vc_header_stage_btn_anchor"
          href={current_url_with_anchor}
        ></a>
      </div>
    )
  }
}

HeaderStageVC.propTypes = {
  bgimage: PropTypes.string,
  bgimagefront: PropTypes.string,
  logo: PropTypes.string,
  headline: PropTypes.string,
  buttonlabel: PropTypes.string,
  buttonanchor: PropTypes.string,
  current_url_with_anchor: PropTypes.string,
}

export default HeaderStageVC
